export default "__VITE_ASSET__D$zOW4Pe__"